import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getOrderReviewsSummary as fetchOrderReviewsSummary,
  getOrderReviews as fetchOrderReviews,
  createOrderReview,
  editOrderReview as updateOrderReview,
  removeOrderReview as deleteOrderReview,
  getOrderReviewById as fetchOrderReviewById,
  forceRemoveOrderReview as forceDeleteOrderReviewService,
} from "./orderReviews.service";
import { RejectValueType } from "../redux/redux.types";
import { handleApiError } from "@/app/utils/handleApiError";
import {
  OrderReviewsSummary,
  OrderReview,
  CreateOrderReviewPayload,
  UpdateOrderReviewPayload,
  OrderReviewDetail,
} from "./orderReviews.types";

export const getOrderReviewsSummary = createAsyncThunk<
  OrderReviewsSummary,
  void,
  RejectValueType
>("orderReviews/getOrderReviewsSummary", async (_, { rejectWithValue }) => {
  try {
    const response = await fetchOrderReviewsSummary();
    return response.data;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const getOrderReviews = createAsyncThunk<
  OrderReview[],
  string | undefined,
  RejectValueType
>("orderReviews/getOrderReviews", async (status, { rejectWithValue }) => {
  try {
    const response = await fetchOrderReviews(status);
    return response.data;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const addOrderReview = createAsyncThunk<
  OrderReviewDetail,
  CreateOrderReviewPayload,
  RejectValueType
>("orderReviews/addOrderReview", async (payload, { rejectWithValue }) => {
  try {
    const response = await createOrderReview(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const editOrderReview = createAsyncThunk<
  OrderReviewDetail,
  UpdateOrderReviewPayload,
  RejectValueType
>("orderReviews/editOrderReview", async (payload, { rejectWithValue }) => {
  try {
    const response = await updateOrderReview(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const removeOrderReview = createAsyncThunk<
  number,
  number,
  RejectValueType
>("orderReviews/removeOrderReview", async (id, { rejectWithValue }) => {
  try {
    await deleteOrderReview(id);
    return id;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const getOrderReviewById = createAsyncThunk<
  OrderReviewDetail,
  number,
  RejectValueType
>("orderReviews/getOrderReviewById", async (id, { rejectWithValue }) => {
  try {
    const response = await fetchOrderReviewById(id);
    return response.data;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const forceRemoveOrderReview = createAsyncThunk<
  number,
  number,
  RejectValueType
>("orderReviews/forceRemoveOrderReview", async (id, { rejectWithValue }) => {
  try {
    await forceDeleteOrderReviewService(id);
    return id;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});
